/* eslint-disable react/jsx-key */
// @flow

import React from 'react'
import { Route } from 'react-router-dom'
import { AnimatedSwitchPagination, ShopsLayout } from './async-loading'
import { ThemeProvider } from '@paypalcorp/pp-react'
import { get } from 'lodash'
import DummyTempComponent from './screens/shops-buyer'
import ProductDetail from './screens/shops-buyer/product-detail'
import SingleItemCartProductDetail from './screens/shops-buyer/product-detail-v1'
import Cart from './screens/shops-buyer/cart'
import clientData from 'utils/client-data'
import ErrorScreen from './screens/seller/error'

import ShopsBuyerStateContainer from './screens/shops-buyer/container'
const isEligibleForShopsWebExperience = get(
  clientData,
  'isEligibleForShopsWebExperience',
  false,
)

const isMultiCartExperienceEnabled = get(
  clientData,
  'isMultiCartExperienceEnabled',
  false,
)

// please make sure you also update the routes on node level in server/src/routes/index.js
const overpanelViews = [
  '/:shopHandle/products/:productId',
  '/buy/success',
  '/:shopHandle/chat',
  '/manage/orders',
  '/manage/orders/:orderId/status',
  '/manage/lists',
  '/buy/cart',
  '/seller/error',
]

export default () => {
  return (
    <Route exact path={overpanelViews}>
      <ShopsLayout>
        <AnimatedSwitchPagination>
          {/*
           * Seller's Product detail page       - /:shopHandle/:productId/details
           * Order success page                 - /buy/success
           * Chat with Seller                   - /:shopHandle/chat
           * See/manage all orders              - /manage/orders
           * Check order status/Cancel order    - /manage/orders/:orderId/status
           * Manage favorites and other lists   - /manage/lists
           * View/Manage cart                   - /buy/cart
           * Error page for shops               - /seller/error
           */}
          {isEligibleForShopsWebExperience && (
            <ShopsBuyerRoute
              exact
              path="/:shopHandle/products/:productId"
              component={
                isMultiCartExperienceEnabled
                  ? ProductDetail
                  : SingleItemCartProductDetail
              }
            />
          )}
          <ShopsBuyerRoute
            exact
            path="/buy/success"
            component={DummyTempComponent}
          />
          <ShopsBuyerRoute
            exact
            path="/:shopHandle/chat"
            component={DummyTempComponent}
          />
          <ShopsBuyerRoute
            exact
            path="/manage/orders"
            component={DummyTempComponent}
          />
          <ShopsBuyerRoute
            exact
            path="/manage/orders/:orderId/status"
            component={DummyTempComponent}
          />
          <ShopsBuyerRoute
            exact
            path="/manage/lists"
            component={DummyTempComponent}
          />
          <ShopsBuyerRoute exact path="/buy/cart" component={Cart} />
          <ShopsBuyerRoute exact path="/seller/error" component={ErrorScreen} />
        </AnimatedSwitchPagination>
      </ShopsLayout>
    </Route>
  )
}

type ReactComponent = () => React.Element | React.Component

function ShopsBuyerRoute({
  component: Comp,
  customProps = {},
  ...props
}: {
  component: ReactComponent,
}) {
  return (
    <Route
      exact
      render={routerProps => (
        <>
          <ThemeProvider theme="v2">
            <ShopsBuyerStateContainer
              {...routerProps}
              body={<Comp {...routerProps} {...customProps} />}
              renderErrorScreen={<DummyTempComponent />}
            />
          </ThemeProvider>
        </>
      )}
      {...props}
    />
  )
}
